<template>
  <section class="custom-upload">
    <div
      ref="dropzone"
      class="dropzone"
      :class="{
        'dropzone--is-dragover': isDragover
      }"
      @drag.stop.prevent
      @dragstart.stop.prevent
      @dragend.stop.prevent="isDragover = false"
      @dragover.stop.prevent="isDragover = true"
      @dragenter.stop.prevent="isDragover = true"
      @dragleave.stop.prevent="isDragover = false"
      @drop.stop.prevent="onDrop" />
    <div class="upload">
      <label
        for="imageUpload"
        class="upload-label">
        <div
          v-ripple
          class="upload-label__fake-input">
          <v-scale-transition
            group
            mode="out-in"
            hide-on-leave
            leave-absolute>
            <v-icon
              v-if="!loading && !isDragover"
              key="upload-icon"
              class="upload-label__icon">
              add_a_photo
            </v-icon>
            <v-icon
              v-if="!loading && isDragover"
              key="dropzone-icon"
              class="upload-label__icon">
              add_circle
            </v-icon>
          </v-scale-transition>
          <v-progress-circular
            v-if="loading"
            key="loading-icon"
            size="60"
            indeterminate
            class="upload-label__loading" />
          {{ isDragover ? 'drop to upload' : 'select an image' }}
        </div>
        <input
          id="imageUpload"
          name="images[]"
          type="file"
          accept="image/*"
          class="upload__input"
          @change="setCurrentFile">
        <i class="upload-label__copyright-release">
          NOTICE: By uploading an image to MemerHats.com, you agree that you own or have permission to use any and all intellectual property within that image. MemerHats Ltd. does not claim ownership of anything submitted to MemerHats.com
        </i>
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PatchUpload',
  data() {
    return {
      loading: false,
      isDragover: false,
      sourceImageURL: '',
    };
  },
  methods: {
    onDrop(event) {
      this.isDragover = false;
      this.loading = true;
      this.setCurrentFile(event);
    },
    setCurrentFile(event) {
      this.loading = true;

      let imageFile;
      if (event.target && event.target.files) {
        [imageFile] = event.target.files;
      }
      if (event.dataTransfer && event.dataTransfer.files) {
        [imageFile] = event.dataTransfer.files;
      }

      const reader = new FileReader();

      reader.onload = (file) => {
        this.$emit('set-source-image', file.target.result);
        this.loading = false;
      };
      reader.readAsDataURL(imageFile);
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.custom-upload
  position: relative
  display: flex
  flex-flow: column nowrap
  align-items: center
  justify-content: center
  height: 100%
  border-radius: $base-border-radius

.dropzone
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  transition: $base-transition
  &::before
    content: ''
    position: absolute
    top: 10%
    left: 10%
    width: 80%
    height: 80%
    color: inherit
    opacity: .12
    transition: $base-transition
  &--is-dragover
    z-index: 1
    &::before
      top: 5%
      left: 5%
      width: 90%
      height: 90%
      background-color: $primary

.upload
  padding: $base-padding
  // border: 2px solid $accent
  // border-radius: $base-border-radius*2
  transition: $base-transition
  cursor: pointer
  &:hover
    border-color: $primary
    & .upload-label__fake-input::before
      background-color: $white
  &__input
    display: none

.upload-label
  display: flex
  flex-flow: column nowrap
  align-items: center
  justify-content: space-between
  text-align: center
  cursor: pointer
  &__icon
    font-size: 4rem
    color: currentColor
  &__loading
    margin: $base-padding*.5 auto
  &__fake-input
    position: relative
    display: flex
    flex-flow: column nowrap
    margin: $base-padding 0
    padding: $base-padding $base-padding*2
    border-radius: $base-border-radius*2
    font-size: 1rem
    font-weight: $base-header-font-weight
    text-transform: uppercase
    color: $secondary
    background-color: $primary
    box-shadow: $base-box-shadow
    &::before
      content: ''
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      color: inherit
      opacity: .12
      transition: $base-transition
  &__copyright-release
    max-width: 28rem
    font-size: .6rem
    font-style: normal
    color: $accent--dark

</style>
